import { useEffect, useState } from 'react';
import SliderInput from '@meitu/saas-ui/es/slider-input';
import './index.less';
import { useStoreActions, useStoreState } from '@/store';

const WatermarkAttribute = () => {
    const [watermarkSpacing, setSpacing] = useState(0);
    const [watermarkCross, setCross] = useState(0);
    const setExtraInfo = useStoreActions((actions) => actions.templateModel.setExtraInfo);
    const extraInfo = useStoreState((state) => state.templateModel.extraInfo);

    useEffect(() => {
        if (extraInfo?.watermarkSpacing && extraInfo.watermarkSpacing !== watermarkSpacing) {
            setSpacing(extraInfo.watermarkSpacing);
        } else if (!extraInfo?.watermarkSpacing) {
            setSpacing(0);
        }

        if (extraInfo?.watermarkCross && extraInfo.watermarkCross !== watermarkCross) {
            setCross(extraInfo.watermarkCross);
        } else if (!extraInfo?.watermarkCross) {
            setCross(0);
        }
    }, [extraInfo]);

    return (
        <div className="c-watermark-attr">
            <div className="item">
                <span>水印间距：</span>
                <SliderInput
                    min={0}
                    max={100}
                    value={watermarkSpacing}
                    disabled={false}
                    precision={1}
                    showStepBtn
                    type="horizontal"
                    onChange={(val: number) => {
                        setExtraInfo({
                            ...extraInfo,
                            watermarkSpacing: val,
                        });
                        setSpacing(val);
                    }}
                    onAfterChange={(val: number) => {}}
                    onClick={() => {}}
                />
            </div>

            <div className="item">
                <span>水印交错：</span>
                <SliderInput
                    min={0}
                    max={100}
                    value={watermarkCross}
                    disabled={false}
                    precision={1}
                    showStepBtn
                    type="horizontal"
                    onChange={(val: number) => {
                        setExtraInfo({
                            ...extraInfo,
                            watermarkCross: val,
                        });
                        setCross(val);
                    }}
                    onAfterChange={(val: number) => {}}
                    onClick={() => {}}
                />
            </div>
        </div>
    );
};

export default WatermarkAttribute;
